import h from 'virtual-dom/h';
import {VChild} from 'virtual-dom';
import {HistoryMessage} from "../../../../types/history";
import {HistoryMessageLiveChatInput, HistoryMessageLiveChatResponse} from "../models/HistoryMessages";


export default class TimestampRenderer
{

    _className: string;
    _shouldDisplayTimestamp: boolean;


    //#region Public Interface

    constructor(className: string, shouldDisplayTimestamp: boolean)
    {
        this._className = className;
        this._shouldDisplayTimestamp = shouldDisplayTimestamp;
    }

    doesRender(message: HistoryMessage): boolean
    {
        const liveChatMessage = message as (HistoryMessageLiveChatInput | HistoryMessageLiveChatResponse);
        const timeCaptured = liveChatMessage?.extensionData?.TimeCaptured;

        return this._shouldDisplayTimestamp && typeof timeCaptured === "string";
    }

    getRender()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const liveChatMessage = message as (HistoryMessageLiveChatInput | HistoryMessageLiveChatResponse);
            const time =  Number(liveChatMessage.extensionData.TimeCaptured);
            const readableTime = (new Date(time)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            return h('div', { className: this._className }, readableTime);
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/timestamp-renderer.ts